var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Button, Link } from "syf-component-library/ui/atoms";
import { useVantageContext } from "../../../context/vantageContext";
var ExternalLink = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  margin: 0;\n  padding: 0px;\n  font-size: 16px;\n  font-weight: 600;\n"], ["\n  display: inline-block;\n  margin: 0;\n  padding: 0px;\n  font-size: 16px;\n  font-weight: 600;\n"])));
var VantageLink = function (_a) {
    var to = _a.to, children = _a.children, className = _a.className, _b = _a.isExternal, isExternal = _b === void 0 ? false : _b;
    var dispatch = useVantageContext().dispatch;
    if (isExternal) {
        return (_jsx(ExternalLink, __assign({ buttonType: "text", onClick: function () {
                dispatch({ isCrossBorderVisible: true, crossBorderUrl: to });
            }, className: className }, { children: children })));
    }
    return (_jsx(Link, __assign({ href: to, target: "_blank", rel: "noreferrer", isInline: true, className: className }, { children: children })));
};
export default VantageLink;
var templateObject_1;
